import SearchHitRow from '../../../../components/search/SearchHitRow';
import React from 'react';
import { PlaylistSearchHitType } from '../../../../types/search';

/**
 * Filter search hit for the retired page.
 */
export const filterTBRSearchHits = (video: PlaylistSearchHitType) =>
  !video?.tags?.find(({ tag }) => tag.toLowerCase() === 'to be retired') &&
  video?.subProducts?.find(
    (v) => v.groupName === 'Clinical Sciences' && v.state === 'active',
  );

/**
 * Render search hits for the retired page.
 */
export const renderSearchHits = (hits: PlaylistSearchHitType[]) => {
  return hits
    .filter(filterTBRSearchHits)
    .slice(0, 5)
    .map((video, index) => (
      <SearchHitRow data={video} key={index} useDeviceSizeFallback />
    ));
};
